import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import ReactHtmlParser from "react-html-parser";

import styled from "styled-components";

import Theme from "@airasia/phoenix-components/components/Theme";
import Title from "@airasia/phoenix-components/components/Title";
import Text from "@airasia/phoenix-components/components/Text";
import Image from "@airasia/phoenix-components/components/Image";
import Button from "@airasia/phoenix-components/components/button"

import "../css/main.css";
import { fireGtmEvent, getGtmUserType } from "../utils/functions";

const TabContent = styled.div`
margin:0 auto;

#howtobook-image img{
width:30%;
}

@media only screen and (max-width: 720px) {
  #howtobook-image img{
    width:80%;
}
}
`

const MerchantWrapper = styled.div`
  width: 100%;
  margin: 3em auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  text-align:center;


  @media only screen and (max-width: 720px) {
    width: 100%;
    gap: 10px;
  }
`;

const Merchant = styled.div`
  display: block;
  width:28%;
  margin:1em auto;
  text-align: center;
  background-color:#eb3223;
  border-radius:20px;
  padding:1em;

  #merchant-image, #howtobook-image  {
    background-color: transparent;
    margin:0em auto;
  }

  @media only screen and (max-width: 720px) {
    width:100%;
    margin-bottom: 2em;
    margin: 1em auto;

    #merchant-image, #howtobook-image  {
    width:100%;
  }

  }


`;

const TitleWrapperFlex = styled.div`
    margin:0 auto;


  #title {
    color: #fff;
    font-weight: 700;
    font-size: 1.2rem;
    margin:10px auto;
  }

  #subtitle{
      line-height:1.5rem;
      display:block;
}

  @media only screen and (max-width: 720px) {
    width: 90%;
    padding-left: 0em;
    padding-right: 0em;

    #title {
      font-size: 1.2rem;
    }
  }
`;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Theme theme="AIRASIA_CLASSIC">
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Theme theme="AIRASIA_CLASSIC">{children}</Theme>
          </Box>
        )}
      </div>
    </Theme>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs(props) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Theme theme="AIRASIA_CLASSIC">
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={value} onChange={handleChange}>
            <Tab label="airasia ride" {...a11yProps(0)} />
          </Tabs>
        </Box>
        <br />
        <TabPanel value={value} index={0}>
          <TabContent>
          <Image
                  accessible
                  placeHolderBackground="none"
                  customProperties={{
                    id: "howtobook-image",
                  }}
                  src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite-airasia-independent-driver.png"
                  alt="งานขับรถอิสระ"
                />
          <Title
            accessible
            inverted={false}
            textAlign="center"
            type="h2"
            color="primary"
          >
            airasia ride
          </Title>
          <Text
            accessible
            display="inlineFlex"
            hasToggle={false}
            opacity={1}
            tag="p"
            textAlign="center"
            translation={{}}
            type="default"
          >
            Mengemudi bersama airasia ride memungkinkan Anda untuk menghasilkan pendapatan tambahan dengan fleksibilitas waktu. Peluang penghasilan lebih banyak dengan potongan komisi rendah sekaligus insentif menarik dengan skema bonus yang kompetitif.
          </Text>
          </TabContent>

          <MerchantWrapper>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_requirement.png"
                alt="Persyaratan"
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  Persyaratan
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  type="p"
                  color="default"
                  customProperties={{ id: "subtitle" }}
                >
                  <ul>
                    <li>Anda memiliki mobil dengan usia kendaraan maksimal 10 tahun</li>
                    <li>Kendaraan Anda cocok untuk mengangkut penumpang</li>
                  </ul>
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_benefits.png"
                alt="Keuntungan "
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  Keuntungan
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  type="p"
                  color="default"
                  customProperties={{ id: "subtitle" }}
                >
                  <ol>
                  <li>Waktu Bebas & Fleksibel. <br />Atur waktu kerja semau Anda.</li>
                  <li>Insentif Menarik. <br />Skema bonus kompetitif.</li>
                  <li>Potongan Komisi Rendah. <br />Bawa hasil lebih banyak.</li>
                  </ol>
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_register.png"
                alt={props.Tab1title3}
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  Proses Pendaftaran
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  color="default"
                  type="p"
                  customProperties={{ id: "subtitle" }}
                >
                  Selesaikan proses registrasi data dengan:
                  <br />
                  <ol>
                    <li>Menyediakan data pribadi</li>
                    <li>Unggah dokumen lengkap melalui Aplikasi Driver.</li>
                  </ol>
                  <ul>
                  <li>*Jika data yang dikirimkan disetujui, kandidat akan menerima pemberitahuan untuk langkah selanjutnya.</li>
                  <li>*Jika data tidak akurat atau tidak lengkap, kandidat akan menerima notifikasi melalui SMS.</li>
                  <li>*Status pendaftaran kandidat dapat diperiksa langsung di aplikasi.</li>
                  </ul>
                </Text>
              </TitleWrapperFlex>
            </Merchant>
          </MerchantWrapper>
        </TabPanel>
      </Box>
    </Theme>
  );
}
